export default {
  GET_ALL: `#graphql
  query getConfigs($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getConfigs(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        config,
        value
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getConfigsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getConfigsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        config,
        value,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewConfig($config: ConfigInput!) {
    newConfig(input: $config)
    {
      config,
      value
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateConfig($config: String!, $configUpdate: ConfigUpdateInput!) {
    updateConfig(config:$config, configUpdate: $configUpdate)
    {
      config
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteConfig($config: String!) {
    deleteConfig(config:$config)
    {
      config
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/config.js